export default __webpack_public_path__ + "static/pub-plus-ca38403a5208ee7694f8a2b78f45345c.svg";